/// <field name='lc' type='Object'>Labour charges object</field>
cafm.hd.lc = {
    listSelector: '#lcLv',
    initHandlerName: 'cafm.hd.lc.onLabourChargesInit',
    preRouteChangeHandlerName: 'cafm.hd.lc.onPreRouteChange',
    changedHandlerName: 'cafm.hd.lc.onLabourChargesChanged',
    startOnWorkOrderStartHandlerName: 'cafm.hd.lc.startOnWorkOrderStartHandlerName',
    init: function () {
        /// <summary>Labour charges initialiser</summary>

        // call init handler
        cafm.handlers.exe(cafm.hd.lc.initHandlerName);

        // remove init handler to ensure this is only called once per registration
        cafm.handlers.remove(cafm.hd.lc.initHandlerName);
    },
    /// <field name='listToolbar' type='Object'>Labour charges list toolbar</field>
    listToolbar: {
        add: function (e) {
            /// <summary>Add handler</summary>
            /// <param name="e" type="Object">The click DOM event</param>

            cafm.hd.lc.helpers.showAddLabourCharge();
        },
        edit: function (e) {
            /// <summary>Edit handler</summary>
            /// <param name="e" type="Object">The click DOM event</param>

            if (cafm.isOffline() || !(cafm.hd.helpers.isTeamLeadForWorkOrder(cafm.hd.workOrder) || cafm.hd.helpers.isHelpdeskOperator())) {

                return;
            }

            var editBtn = $(e.target);
            var editTarget = editBtn.data('editTarget');
            var lv = editBtn.getLvFromTb();
            var id = editTarget.data('id');

            if (!id) {

                $('#labourChargesPlc').showMessage({ Type: cafm.enums.MessageType.Warning, Title: cafm.res.str.HDMessageNoLabourChargesSelected });
                return;
            }
            else {

                $('#labourChargesPlc').hideMessage();
            }

            var labourCharge = lv.element.getListViewDataItem(id);
            labourCharge = cafm.util.clone(labourCharge, true);

            // convert to hours and minute integers as that's what the server will be expecting..
            var totalMins = labourCharge.Hours * 60;
            labourCharge.Hours = parseInt(totalMins / 60);
            labourCharge.Minutes = Math.round(totalMins % 60);

            cafm.hd.lc.helpers.showEditLabourCharge(labourCharge);
        },
        remove: function (e) {
            /// <summary>Delete handler</summary>
            /// <param name="e" type="Object">The click DOM event</param>

            // hide the labour charges message
            $('#labourChargesPlc').hideMessage();

            var ids = $(e.target).getListSelectedParentChildArray({ parentId: cafm.hd.workOrder.get('ID') });
            if (!ids) {
                $('#labourChargesPlc').showMessage({ Type: cafm.enums.MessageType.Warning, Title: cafm.res.str.HDMessageNoLabourChargesSelected });
                return;
            }

            cafm.actions.execute({
                url: cafm.url.api('WorkOrder/RemoveLabourCharges'),
                values: ids,
                elementId: 'labourChargesPlc',
                loaderSelector: '#labourChargesPlc',
                preventValidate: true,
                statusCodeFuncs: {
                    200: function (r) {

                        cafm.handlers.exe(cafm.hd.lc.changedHandlerName, r);
                        cafm.hd.lc.refreshList();
                        $('#labourChargesPlc').showMessage({ Type: cafm.enums.MessageType.Success, Title: cafm.res.str.MessageItemsDeleted });

                        if (cafm.getClientSettings().helpdeskSettings.labourChargesMode == cafm.enums.LabourChargesMode.StartEndRealTimeRecording) {

                            cafm.hd.refreshNavigation();
                        }
                    }
                }
            });           
        }
    },
    editToolbar: {
        submit: function (e) {

            var labourCharge = cafm.views.getActionWindowViewModel(),
                isNew = !cafm.util.guidHasValue(labourCharge.ID),
                path, msg, offlineAction;

            if (isNew) {

                path = 'WorkOrder/AddLabourCharge';
                msg = cafm.res.str.HDMessageLabourChargeAdded;
                offlineAction = cafm.enums.OfflineActionType.AddLabourCharge;
            }
            else {

                path = 'WorkOrder/UpdateLabourCharge';
                msg = cafm.res.str.HDMessageLabourChargeUpdate;
            }

            cafm.actions.execute({
                url: cafm.url.api(path),
                elementId: 'actionFormPlc',
                loaderSelector: '.winButtons .btn[data-key="Submit"]',
                values: labourCharge,
                offlineActionType: offlineAction,
                statusCodeFuncs: {
                    200: function (r) {

                        cafm.handlers.exe(cafm.hd.lc.changedHandlerName, r);
                        cafm.hd.lc.refreshList();
                        cafm.hd.actions.closeActionWindow();
                        $('#labourChargesPlc').showMessage({ Type: cafm.enums.MessageType.Success, Title: msg });

                        // explicitly call this method as the list may not be open to auto refresh the labour charges count
                        cafm.hd.setWorkOrderChildCounts(r);
                    }
                },
                fallback: function() {

                    labourCharge.ID = cafm.guid.empty;
                    labourCharge.ChargeStatus = cafm.enums.ActivityStatus.Completed;
                    labourCharge.ChargeStartDateTime = cafm.util.toIsoDateString(labourCharge.ChargeStartDateTime);

                    if (cafm.util.guidHasValue(labourCharge.AssignedPersonID)) {

                        var kddl = $('#assignedPersonSelect').find('select.cfControl').getKendoDropDownList();
                        labourCharge.AssignedPersonDescription = kddl ? kddl.text() : labourCharge.AssignedPersonDescription;
                    }

                    if (cafm.util.guidHasValue(labourCharge.ChargeRateCodeID)) {

                        var kddl = $('#chargeRateDropdown').find('select.cfControl').getKendoDropDownList();
                        labourCharge.ChargeRateCodeDescription = kddl ? kddl.text() : null;
                    }

                    if (cafm.util.guidHasValue(labourCharge.OvertimeRateCodeID)) {

                        var kddl = $('#overtimeRateDropdown').find('select.cfControl').getKendoDropDownList();
                        labourCharge.OvertimeRateCodeDescription = kddl ? kddl.text() : null;
                    }

                    labourCharge.HoursAndMinutes = cafm.util.timeSpanToString({
                        hours: true,
                        minutes: true,
                        separator: ' ',
                        timeSpan: {
                            hours: labourCharge.Hours,
                            minutes: labourCharge.Minutes
                        }
                    });

                    var lbl = cafm.hd.getWorkOrderChildList('LabourCharges');

                    if (isNullOrUndefined(lbl)) lbl = [];

                    lbl.push(labourCharge);

                    cafm.hd.workOrder.set('LabourCharges', lbl);
                    cafm.hd.workOrder.set('LabourChargesCount', lbl.length);

                    // call changed handler
                    cafm.handlers.exe(cafm.hd.lc.changedHandlerName, cafm.hd.workOrder);

                    // refresh the labour charges list
                    cafm.hd.lc.refreshList();

                    // end the offline action (caches work order, refreshes toolbar and closes form)
                    hdActions.helpers.endOfflineAction({
                        cacheWorkOrder: true,
                        refreshToolbar: true
                    });
                },
                validationMessage: cafm.res.str.HDMessageLabourChargeInvalid
            });
        },
        cancel: function (e) {
            /// <summary>Handler for when cancelling out of labour charge creation or edits</summary>
            /// <param name="e" type="Object">DOM event</param>

            cafm.hd.actions.closeActionWindow();
        }
    },
    refreshList: function () {
        /// <summary>Refresh the labour charge list</summary>

        cafm.util.refreshList({
            listSelector: cafm.hd.lc.listSelector,
            key: cafm.res.consts.DataKey_HelpdeskLabourCharges
        });
    },
    enablePermissibleFeatures: function (p) {
        /// <summary>Enables labour charge features</summary>
        /// <param name="p" type="Object">Labour charge permissions object</param>

        // TODO: Temporary Workaround
        // when offline this is fired twice - 200 callback method is being called after fallback
        // first time with permissions and second with a fallback response
        if (isDefined(p.responseText)) return;

        var ht = $('{0} .cLvHead .cTb'.format(cafm.hd.lc.listSelector));
        
        if (p.add || p.remove || p.start || p.complete) {

            var addEl = $('#' + cafm.res.consts.ElementId_AddLabourChargeButton),
                startEl = $('#' + cafm.res.consts.ElementId_StartLabourChargeButton),
                compEl = $('#' + cafm.res.consts.ElementId_CompleteLabourChargeButton);

            if (p.add === true) {

                addEl.show();
            }

            if (p.start === true) {

                startEl.show();
            }

            if (p.complete === true) {

                compEl.show();
            }
        }

        if (p.add || p.remove) {

            ht.show();
        }
        else {

            ht.hide();
        }
        
        var assPpl = $('#assignedPeople'), 
            w = cafm.hd.workOrder;

        // if the current user is a helpdesk operator or principal or team lead for an assigned trade
        if (cafm.hd.helpers.isHelpdeskOperator() || cafm.hd.helpers.isPrincipalOrTeamLeadForWorkOrder(w)) {

            var tradePpl = cafm.hd.helpers.getAllTradePeopleForWorkOrder(w),
                pid = cafm.auth.personId();
            
            // if there are assigned trade people
            if (cafm.util.hasItem(tradePpl)) {

                var kddl = assPpl.find('select.cfControl').getKendoDropDownList();

                // push all item to front of array
                tradePpl.unshift({
                    FullName: cafm.res.str.TextAllWithBrackets,
                    ID: ''
                });

                // set data
                kddl.dataSource.data(tradePpl);

                // set default filter to current user if they are assigned and when the user is principal and not team leader
                if (cafm.hd.helpers.isPrincipalForWorkOrder(w) && !cafm.hd.helpers.isTeamLeadForWorkOrder(w)) {

                    // check if the current person is an assigned trade person
                    var match = cafm.util.find(tradePpl, function (p) {

                        return p.ID == pid;
                    });

                    // if so set the dropdown
                    if (match) {

                        kddl.value(match.ID);
                        kddl.text(match.Description);
                    }
                }

                // show the filter
                assPpl.css('display', 'block');
            }
        }
        else {

            // otherwise hide the filter
            assPpl.hide();
        }

        // now bind the list
        cafm.hd.lc.refreshList();
    },
    enablePermissibleFeaturesOffline: function () {
        /// <summary>Enable labour charge features offline using offline security handler</summary>
    
        var p = {

            view: true,
            remove: false, // never allowed offline
            add: hdActions.offlineSecurity.isAllowed(cafm.enums.LogWorkOrderAction.AddLabourCharge),
            start: hdActions.offlineSecurity.isAllowed(cafm.enums.LogWorkOrderAction.StartLabourCharge),
            complete: hdActions.offlineSecurity.isAllowed(cafm.enums.LogWorkOrderAction.CompleteLabourCharge)
        };

        cafm.hd.lc.enablePermissibleFeatures(p);
    },
    handlers: {
        
        dataRetrieved: function (d) {
            /// <summary>Handler for when labour charge list data has been retrieved</summary>
            /// <param name="d" type="Array">Array of labour charge data</param>          
        },
        onAssigneeChange: function (e) {
            /// <summary>Handler for the labour charge list assignee filter changed event</summary>
            /// <param name="e" type="Object">Event object</param>

            cafm.hd.lc.refreshList();
        },
        preBuildControl: function (options) {

            if (options.Selectable) {
                options.Selectable = cafm.hd.helpers.isTeamLeadForWorkOrder(cafm.hd.workOrder) || cafm.hd.helpers.isHelpdeskOperator();
            }
        },
        start: {
            /// <summary>Start labour charge handlers</summary>

            cancel: function () {
                
                // check for labour charge start handler, if there is one and it returns false then stop execution here
                if (cafm.handlers.exists(cafm.hd.lc.startOnWorkOrderStartHandlerName)) {

                    cafm.handlers.exe(cafm.hd.lc.startOnWorkOrderStartHandlerName);
                }

                cafm.toolbar.standardActionToolbar.cancel();
            },
            load: function (args) {
                /// <summary>Determines if an element is scrollable or not</summary>
                /// <param name="args" type="Object">Start view load options</param>

                var chargeRateDdl = $('#chargeRateDropdown'),
                    overtimeRateDdl = $('#overtimeRateDropdown');

                if (args.allowOverrideChargeRate) {

                    chargeRateDdl.show();
                    overtimeRateDdl.show();
                }
                else if (!args.defaultChargeRate) {

                    chargeRateDdl.show();
                }

                // show or remove the start date field
                if (cafm.isOffline()) {

                    // fallback to the cached dropdowns
                    chargeRateDdl.replaceWith('<div id="chargeRateWrapper" class="cfFieldWrapper"></div>');
                    overtimeRateDdl.replaceWith('<div id="overtimeRateWrapper" class="cfFieldWrapper"></div>');
                    cafm.hd.lc.helpers.fallbackToOfflineChargeRates(function () {

                        // bind the labour charge
                        cafm.views.bindActionWindowViewModel(args.viewModel);
                    });
                }
                else {

                    // bind the labour charge
                    cafm.views.bindActionWindowViewModel(args.viewModel);
                }
            },
            startlabourcharge: function (input) {
                /// <summary>Start labour charge handler function</summary>
                /// <param name="input" type="Object">Either dom object or labour charge DTO expected</param>
                
                var dto,
                    inputProvided = !input || isNullOrUndefined(input.target);
                // if dto not supplied then get it (input is either going to be the dto or the dom event args)

                if (!inputProvided) {

                    dto = cafm.views.getActionWindowViewModel();
                }
                else {

                    dto = input;
                }

                dto.WorkOrderID = cafm.hd.workOrder.ID;
                dto.AssignedPersonID = cafm.auth.personId();
                dto.ChargeStartDateTime = cafm.web.funcs.getNowUTC({ truncateToMinutes: true });
          

                // check for labour charge start handler, if there is one and it returns false then stop execution here
                if (cafm.handlers.exists(cafm.hd.lc.startOnWorkOrderStartHandlerName) && !cafm.handlers.exe(cafm.hd.lc.startOnWorkOrderStartHandlerName, dto)) return;
                
                cafm.actions.execute({
                    url: cafm.url.api('WorkOrder/StartLabourCharge'),
                    elementId: 'actionFormPlc',
                    loaderSelector: inputProvided ? '#main' : '.winButtons .btn[data-key="StartLabourCharge"]',
                    loaderText: cafm.res.str.MessageStartingLabourCharge,
                    values: dto,
                    offlineActionType: cafm.enums.OfflineActionType.StartLabourCharge,
                    statusCodeFuncs: {
                        200: function (r) {

                            cafm.handlers.exe(cafm.hd.lc.changedHandlerName, r);

                            // refresh the labour charges list
                            cafm.hd.lc.refreshList();

                            // end actions to be executed on desktop and mobile
                            var endActions = function () {

                                // show success message
                                cafm.hd.lc.helpers.showMessage(cafm.res.str.MessageLabourChargeStarted, cafm.enums.MessageType.Success);

                                // close action window
                                cafm.hd.actions.closeActionWindow();
                            }

                            if (isMobile) {

                                // refresh navigation
                                cafm.hd.refreshNavigation();

                                // call end actions
                                endActions();
                            }
                            else {

                                // refresh navigation and call end actions on load
                                cafm.hd.refreshNavigation(endActions);
                            }
                        }
                    },
                    fallback: function () {

                        cafm.hd.lc.handlers.start.startLabourChargeOffline(dto);
                    }
                });
            },
            startLabourChargeOffline: function (dto) {
                /// <summary>Start labour charge offline handler function</summary>
                /// <param name="dto" type="Object">Labour charge DTO</param>

                dto.ID = cafm.guid.empty;
                dto.ChargeStartDateTime = cafm.util.toIsoDateString(dto.ChargeStartDateTime);
                dto.AssignedPersonDescription = cafm.auth.personName();
                dto.ChargeStatus = cafm.enums.ActivityStatus.InProgress;
                dto.ChargeCreateMode = cafm.enums.LabourChargeCreateMode.StartComplete;
                dto.HoursAndMinutes = '';

                if (cafm.util.guidHasValue(dto.ChargeRateCodeID)) {

                    var kddl = $('#chargeRateDropdown').find('select.cfControl').getKendoDropDownList();
                    dto.ChargeRateCodeDescription = kddl ? kddl.text() : null;
                }

                if (cafm.util.guidHasValue(dto.OvertimeRateCodeID)) {

                    var kddl = $('#overtimeRateDropdown').find('select.cfControl').getKendoDropDownList();
                    dto.OvertimeRateCodeDescription = kddl ? kddl.text() : null;
                }

                var lbl = cafm.hd.getWorkOrderChildList('LabourCharges');

                if (isNullOrUndefined(lbl)) lbl = [];

                lbl.push(dto);

                cafm.hd.workOrder.set('LabourCharges', lbl);
                cafm.hd.workOrder.set('LabourChargesCount', lbl.length);

                // call changed handler
                cafm.handlers.exe(cafm.hd.lc.changedHandlerName, cafm.hd.workOrder);

                // refresh the labour charges list
                cafm.hd.lc.refreshList();

                // end the offline action (caches work order, refreshes toolbar and closes form)
                hdActions.helpers.endOfflineAction({
                    cacheWorkOrder: true,
                    refreshToolbar: true
                });
            }
        }
    },
    helpers: {

        canViewAllLabourCharges: function () {
            /// <summary>Can view all labour charges helper</summary>
            /// <returns type="Boolean">True if the user can view all labour charges</returns>

            return cafm.hd.helpers.isHelpdeskOperator() || cafm.hd.helpers.isPrincipalOrTeamLeadForWorkOrder(cafm.hd.workOrder);
        },
        completeLabourCharge: function (e) {
            /// <summary>Start labour charge handler function</summary>
            /// <param name="e" type="Object">Event object</param>

            // build the complete DTO
            var dto = {

                WorkOrderID: cafm.hd.workOrder.ID,
                AssignedPersonID: cafm.auth.personId(),
                ChargeCompleteDateTime: cafm.web.funcs.getNowUTC({ truncateToMinutes: true })
            };

            var inProgress = cafm.hd.lc.helpers.getInProgressLabourChargeForPerson(cafm.auth.personId());

            if (!inProgress) {

                cafm.hd.lc.helpers.showMessage(cafm.res.str.MessageNoLabourChargeInProgress, cafm.enums.MessageType.Warning);
                return;
            }
            else if ((cafm.util.ensureDate(dto.ChargeCompleteDateTime).getTime() - cafm.util.ensureDate(inProgress.ChargeStartDateTime).getTime()) < 60000) {

                cafm.hd.lc.helpers.showMessage(cafm.res.str.MessageLabourChargeCompleteMustBeLaterThanStart, cafm.enums.MessageType.Error);
                return;
            }

            // hide the labour charges message
            $('#labourChargesPlc').hideMessage(true);
            
            // execute the complete action
            cafm.actions.execute({
                url: cafm.url.api('WorkOrder/CompleteLabourCharge'),
                loaderTarget: '#main',
                loaderText: cafm.res.str.MessageCompletingLabourCharge,
                values: dto,
                offlineActionType: cafm.enums.OfflineActionType.CompleteLabourCharge,
                statusCodeFuncs: {
                    200: function (r) {

                        // call changed handler
                        cafm.handlers.exe(cafm.hd.lc.changedHandlerName, r);

                        // refresh labour charges list
                        cafm.hd.lc.refreshList();

                        // end actions to be executed on desktop and mobile
                        var endActions = function () {
                            
                            // show success message
                            cafm.hd.lc.helpers.showMessage(cafm.res.str.MessageLabourChargeCompleted, cafm.enums.MessageType.Success);
                        }

                        if (isMobile) {

                            if (cafm.hd.lc.ticker) cafm.hd.lc.ticker.stop().hide();

                            // refresh navigation
                            cafm.hd.refreshNavigation();

                            // call end actions
                            endActions();
                        }
                        else {

                            // refresh navigation and call end actions on load
                            cafm.hd.refreshNavigation(endActions);
                        }
                    }
                },
                fallback: function () {

                    // get the existing labour charge
                    var labourCharge = cafm.hd.lc.helpers.getInProgressLabourChargeForPerson(cafm.auth.personId());

                    if (labourCharge) {

                        labourCharge.ChargeStatus = cafm.enums.ActivityStatus.Completed;
                        labourCharge.ChargeCompleteDateTime = cafm.util.toIsoDateString(dto.ChargeCompleteDateTime);
                        labourCharge.HoursAndMinutes = cafm.util.timeSpanToString({
                            hours: true,
                            minutes: true,
                            timeSpan: cafm.util.datesHoursMinsDiff(labourCharge.ChargeStartDateTime, labourCharge.ChargeCompleteDateTime)
                        });

                        // call changed handler
                        cafm.handlers.exe(cafm.hd.lc.changedHandlerName, cafm.hd.workOrder);

                        // refresh the labour charges list
                        cafm.hd.lc.refreshList();

                        if (cafm.hd.lc.ticker) cafm.hd.lc.ticker.stop().hide();

                        // end the offline action (caches work order, refreshes toolbar and closes form)
                        hdActions.helpers.endOfflineAction({
                            cacheWorkOrder: true,
                            refreshToolbar: true
                        });
                    }
                    else {

                        console.log('No existing labour charge in progress for the current person.');
                    }
                }
            });
        },
        fallbackToOfflineChargeRates: function (callback) {
            /// <summary>Helper to show offline charge rates instead of online controls</summary>
            /// <param name="callback" type="Function">Function to execute once the offline rate controls are ready</param>

            // charge rate fallback
            $('#chargeRateWrapper').loadView({
                url: cafm.url.get('Helpdesk/LabourChargeRateDropdown'),
                isForm: true,
                onLoad: function () {
                    cafm.hd.lc.helpers.removeInvalidCodes($('#chargeRateWrapper'), cafm.hd.workOrder.ValidOfflineChargeRateCodeIds);
                    // overtime rate fallback
                    $('#overtimeRateWrapper').loadView({
                        url: cafm.url.get('Helpdesk/LabourChargeOvertimeRateDropdown'),
                        isForm: true,
                        onLoad: function () {
                            cafm.hd.lc.helpers.removeInvalidCodes($('#overtimeRateWrapper'), cafm.hd.workOrder.ValidOfflineOvertimeRateCodeIds);
                            callback();
                        }
                    });
                }
            });
        },
        removeInvalidCodes: function (wrapper, validCodes) {

            validCodes = validCodes || [];

            let select = $("select.cfControl[data-bind*='CodeID']", wrapper);
            let kddl = select.getKendoDropDownList();
            let items = kddl.dataSource.data();

            cafm.util.removeWhere(items, function (item) {
                var ind = validCodes.indexOf(item.value);
                return ind < 0; 
            });

            kddl.setDataSource(items);

        },
        getInProgressLabourChargeForPerson: function (personId, workOrder) {
            /// <summary>Get in progress labour charge for person if there is one - null returned otherwise</summary>
            /// <param name="personId" type="String">Person guid</param>
            /// <returns type="Object">The in progress labour charge</returns>

            return cafm.util.find(!workOrder ? cafm.hd.getWorkOrderChildList('LabourCharges') : workOrder.LabourCharges, function (lc) {

                return lc.ChargeStatus === cafm.enums.ActivityStatus.InProgress && lc.AssignedPersonID == personId;
            });
        },
        getLabourCharges: function () {
            /// <summary>Gets labour charges to display, with filters applied</summary>
            /// <returns type="Array">Array of labour charges</returns>

            var pid, res;

            // if the user can't view all labour charges then set person ID
            if (!cafm.hd.lc.helpers.canViewAllLabourCharges()) {

                pid = cafm.auth.personId();
            }
            
            // check the person ui filter if there is no person ID already set
            if (!cafm.util.guidHasValue(pid)) {

                var kddl = $('#assignedPeople').find('select.cfControl').getKendoDropDownList();

                // extract the kendo dropdown value
                if (kddl) {
                    pid = kddl.value();
                }
            }

            // is there a person ID
            if (pid) {
                
                res = cafm.hd.workOrder.LabourCharges;

                // ensure it's a plain old js array
                if (res && res.toJSON) res = res.toJSON();

                // set unfiltered total for the headings
                $('#lcLv .cLv').data('unfilteredTotal', res ? res.length : 0);

                // now filter by the person ID
                res = cafm.util.where(res, function (lc) {

                    return lc.AssignedPersonID == pid;
                });

                // set unfiltered total for the headings
                $('#lcLv .cLv').data('filteredTotal', res ? res.length : 0);
            }
            else {

                // just return all labour charges
                res = cafm.hd.workOrder.LabourCharges;
            }

            return cafm.util.ensureValue(res, []);
        },
        hasInProgressLabourChargeForPerson: function (personId) {
            /// <summary>Determines if there is an in progress labour charge for a person</summary>
            /// <param name="personId" type="String">Person guid</param>
            /// <returns type="Boolean">True if the person has an in progress labour charge</returns>

            return cafm.util.exists(cafm.hd.getWorkOrderChildList('LabourCharges'), function (lc) {

                return lc.ChargeStatus === cafm.enums.ActivityStatus.InProgress && lc.AssignedPersonID == personId;
            });
        },
        renderLabourChargeTicker: function (workOrder) {
            
            var inProgressCharge = cafm.hd.lc.helpers.getInProgressLabourChargeForPerson(cafm.auth.personId(), workOrder);
            if (inProgressCharge) {

                if (cafm.hd.lc.ticker) {

                    // refresh the ticker
                    cafm.hd.lc.ticker.refresh({ startTime: inProgressCharge.ChargeStartDateTime, start: true, textOnStart: cafm.res.str.MessageLabourChargeStarted }).show();
                }
                else {

                    // render the ticker
                    cafm.hd.lc.ticker = cafm.CAFMReactDOM.render('HoursTicker', { startTime: inProgressCharge.ChargeStartDateTime, start: true, showSeconds: false, textOnStart: cafm.res.str.MessageLabourChargeStarted }, document.getElementById('header-details-footer'), null, true).show();

                    // clear ticker when the route changes
                    cafm.handlers.set(cafm.hd.lc.preRouteChangeHandlerName, function () { cafm.hd.lc.ticker = null; });
                }
            }
        },
        setupAdhocLabourChargeForm: function (args) {
            /// <summary>Sets up an adhoc labour charge form</summary>
            /// <param name="args" type="Object">Arguments object including options labourCharge and isEndTask</param>

            // local vars
            var isNew,
                personDdl = $('#assignedPersonSelect').find('select.cfControl').getKendoDropDownList(),
                workOrder = cafm.hd.workOrder,
                tradePpl = cafm.hd.helpers.getTradePeopleForWorkOrder(workOrder),
                defaultChargeRate = cafm.hd.helpers.getDefaultChargeRate(workOrder),
                helpdeskSettings = cafm.getClientSettings().helpdeskSettings,
                isEndTask = args ? args.isEndTask : false;
            
            if (!cafm.util.hasItem(tradePpl)) {

                console.log('No trade people assigned');
                return;
            }

            // set trade people data source
            personDdl.dataSource.data(tradePpl);

            if (!args || !args.labourCharge) {

                labourCharge = {};
            }
            else {

                labourCharge = args.labourCharge;
            }

            // if labour charge has no ID then its new)
            isNew = !cafm.util.guidHasValue(labourCharge.ID);

            // if the labour charge is new
            if (isNew) {

                labourCharge.WorkOrderID = workOrder.ID;
                labourCharge.ChargeStartDateTime = cafm.web.funcs.getNowUTC();

                switch(cafm.getClientSettings().helpdeskSettings.labourChargesMode) 
                {
                    case cafm.enums.LabourChargesMode.StartEndRealTimeRecording:

                        labourCharge.ChargeCreateMode = cafm.enums.LabourChargeCreateMode.StartComplete;
                        break;

                    default:
                        
                        labourCharge.ChargeCreateMode = cafm.enums.LabourChargeCreateMode.AdhocHours;
                        break;
                }

                // if this is any engineer then set them as the assigned person
                if (cafm.hd.helpers.isAnyEngineer()) {

                    labourCharge.AssignedPersonID = cafm.auth.personId();
                    labourCharge.AssignedPersonDescription = cafm.auth.personName();
                }

                // if there's a default charge rate then set it
                if (!cafm.util.guidHasValue(labourCharge.ChargeRateCodeID) && defaultChargeRate && cafm.util.guidHasValue(defaultChargeRate.ID)) {

                    labourCharge.ChargeRateCodeID = defaultChargeRate.ID;
                    labourCharge.ChargeRateCodeDescription = defaultChargeRate.Description;
                }
            }

            // show labour charge assigned person flag
            if (!isNew || isEndTask || !(cafm.hd.helpers.isHelpdeskOperator() || cafm.hd.helpers.isPrincipalOrTeamLeadForWorkOrder(workOrder))) {

                $('#assignedPersonWrapper').remove();
            }

            // show rates flag
            labourCharge.allowOverrideChargeRate = helpdeskSettings.allowOverrideChargeRate || !cafm.util.guidHasValue(labourCharge.ChargeRateCodeID);
            labourCharge.allowOverrideOvertimeRate = helpdeskSettings.allowOverrideChargeRate;

            // show or remove the start date field
            if (cafm.isOffline()) { 

                // fallback to the cached dropdowns
                cafm.hd.lc.helpers.fallbackToOfflineChargeRates(function () {

                    // bind the labour charge
                    cafm.views.bindActionWindowViewModel(labourCharge);
                });
            }
            else {

                // bind the labour charge 
                cafm.views.bindActionWindowViewModel(labourCharge);
            }

            var actionForm = cafm.views.getActionForm();

            switch (labourCharge.ChargeCreateMode) {

                case cafm.enums.LabourChargeCreateMode.AdhocHours:

                    actionForm.find('#labourChargeCompleteWrapper').remove();
                    break;

                case cafm.enums.LabourChargeCreateMode.StartComplete:
                        
                    var hoursNtb = actionForm.find('#Hours').getKendoNumericTextBox(),
                        minsNtb = actionForm.find('#Minutes').getKendoNumericTextBox(),
                        pvm = cafm.views.getActionWindowViewModel();

                    hoursNtb.enable(false);
                    minsNtb.enable(false);

                    var dateChange = function (args) {

                        var pvm = args.sender.source;

                        if(cafm.util.arrayContains(['ChargeStartDateTime','ChargeCompleteDateTime'], args.field)) {

                            var start = pvm.get('ChargeStartDateTime'),
                            complete = pvm.get('ChargeCompleteDateTime');

                            if (start && complete) {

                                var diff = cafm.util.datesHoursMinsDiff(start, complete);

                                if(diff) {

                                    if(diff.hours > 0){

                                        pvm.set('Hours', diff.hours);
                                    }
                                    else {

                                        pvm.set('Hours', 0);
                                    }

                                    if (diff.minutes > 0) {

                                        pvm.set('Minutes', diff.minutes);
                                    }
                                    else {

                                        pvm.set('Minutes', 0);
                                    }
                                }
                            }
                        }
                    }

                    pvm.bind('change', dateChange);

                    break;
            }
        },
        showAddLabourCharge: function (args) {
            /// <summary>Show add adhoc labour charge form</summary>
            /// <param name="args" type="Object">Add adhoc labour charge options object</param>

            // hide the labour charges message
            $('#labourChargesPlc').hideMessage();

            cafm.views.openChildActionWindow({
                action: 'Helpdesk/NewLabourCharge',
                title: cafm.res.str.TitleAddLabourCharge,
                onLoad: function () {
                    cafm.hd.lc.helpers.setupAdhocLabourChargeForm(args);
                }
            });
        },
        showEditLabourCharge: function (labourCharge) {
            /// <summary>Show edit labour charge form</summary>
            /// <param name="labourCharge" type="Object">The labour charge client object</param>

            // hide the labour charges message
            $('#labourChargesPlc').hideMessage();
            
            cafm.views.openChildActionWindow({
                action: cafm.url.get('Helpdesk/EditLabourCharge'),
                title: cafm.res.str.TitleEditLabourCharge,
                onLoad: function () {

                    cafm.hd.lc.helpers.setupAdhocLabourChargeForm({
                        labourCharge: labourCharge
                    });
                }
            });
        },
        showMessage: function (title, type) {
            /// <summary>Shows a message in the labour charges section</summary>
            /// <param name="title" type="String">The message title</param>
            /// <param name="type" type="cafm.enums.MessageType">The message type</param>

            var hasLoaded = cafm.hd.hasTabLoaded(cafm.res.consts.DataKey_HelpdeskLabourCharges), // hasLoaded labour charges section loaded flag
                showMsg = function () { // message function to be called immediately or on init of labour charges section

                    $('#labourChargesPlc').showMessage({

                        title: title,
                        type: type,
                        transition: cafm.msg.Transition.None,
                        scrollToElement: isMobile
                    });
                };

            // if section isn't active then open it now
            if (!cafm.forms.isActiveFormSection(cafm.res.consts.DataKey_HelpdeskLabourCharges)) {
                
                cafm.forms.openFormSection(cafm.res.consts.DataKey_HelpdeskLabourCharges);
            }
            
            // if tab isn't loaded yet then defer message func call to the init labour charges section event
            if (hasLoaded) {

                showMsg();
            }
            else {

                cafm.handlers.set(cafm.hd.lc.initHandlerName, showMsg);
            }
        },
        showStartLabourCharge: function (args) {
            /// <summary>Shows the start labour charge form</summary>
            /// <param name="args" type="Object">Optional options object (if lncluded contains formContainer element option)</param>

            // hide the labour charges message
            $('#labourChargesPlc').hideMessage();

            var viewModel = {},
                defaultChargeRate = cafm.hd.helpers.getDefaultChargeRate(cafm.hd.workOrder),
                allowOverrideChargeRate = cafm.getClientSettings().helpdeskSettings.allowOverrideChargeRate;

            if (defaultChargeRate) {

                viewModel.ChargeRateCodeID = defaultChargeRate.ID;
                viewModel.ChargeRateCodeDescription = defaultChargeRate.Description;
            }

            if (!allowOverrideChargeRate && defaultChargeRate) {

                cafm.hd.lc.handlers.start.startlabourcharge(viewModel);
            }
            else {

                if (args && isJQuery(args.formContainer)) {
                    
                    $('.actionWindow .winButtons').remove();

                    args.formContainer.loadView({
                        url: cafm.url.get('Helpdesk/StartLabourCharge'),
                        viewModel: viewModel,
                        initialText: cafm.res.str.TextPreparingForm,
                        noRenderEffect: isMobile,
                        onLoad: function (pnl) {
                            
                            cafm.hd.lc.handlers.start.load({
                                viewModel: viewModel,
                                defaultChargeRate: defaultChargeRate,
                                allowOverrideChargeRate: allowOverrideChargeRate
                            });

                            if (isMobile) {
                                pnl.prepend($('<header class="mobileActionHeader"><h1 class="mobileActionTitle">{0}</h1></header>'.format(cafm.res.str.TitleStartLabourCharge)));
                            }
                            else {
                                $('.k-window-title').text(cafm.res.str.TitleStartLabourCharge);
                            }
                        },
                        isForm: true
                    })
                }
                else {

                    cafm.views.openChildActionWindow({
                        action: 'Helpdesk/StartLabourCharge',
                        height: cafm.views.actionWindowConfig.small.height(),
                        onLoad: function (panel) {

                            cafm.hd.lc.handlers.start.load({

                                viewModel: viewModel,
                                defaultChargeRate: defaultChargeRate,
                                allowOverrideChargeRate: allowOverrideChargeRate
                            });
                        }
                    });
                }
            }
        }
    }
}